import { put, call } from 'redux-saga/effects'
import { handleError, operatorsAlertApiService } from 'Services/ApiService.js'
import OperatorAlertsActions from 'Stores/Alert/Actions'
import { encodeObjectToBase64 } from '../Utils/base64functions'
import { IFToastMessage } from 'Components'
import { toaster } from 'rsuite'

export function* fetchOperatorsAlerts({ filter, offset }) {
  if (offset == 0) {
    yield put(OperatorAlertsActions.fetchOperatorsAlertsLoading())
  } else {
    yield put(OperatorAlertsActions.fetchOperatorsAlertsLoadingMore())
  }
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(operatorsAlertApiService.get, `/`, {
      params: {
        filter: filter,
        offset: offset,
      },
    })
    yield put(
      OperatorAlertsActions.fetchOperatorsAlertsSuccess(
        offset,
        data.alerts,
        data.nextOffset,
      ),
    )
  } catch (e) {
    yield put(OperatorAlertsActions.fetchOperatorsAlertsFail())
    handleError(e)
  }
}
export function* fetchAlertChargePoints({ filter, offset }) {
  if (offset == 0) {
    yield put(OperatorAlertsActions.fetchAlertChargePointsLoading())
  } else {
    yield put(OperatorAlertsActions.fetchAlertChargePointsLoadingMore())
  }
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(
      operatorsAlertApiService.get,
      `/alerts/allChargePoints`,
      {
        params: {
          filter: filter,
          offset: offset,
        },
      },
    )
    yield put(
      OperatorAlertsActions.fetchAlertChargePointsSuccess(
        offset,
        data.chargePoints,
        data.nextOffset,
      ),
    )
  } catch (e) {
    yield put(OperatorAlertsActions.fetchAlertChargePointsFail())
    handleError(e)
  }
}
export function* fetchAlertCount({ filter }) {
  yield put(OperatorAlertsActions.fetchOperatorsAlertsCountLoading())
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(operatorsAlertApiService.get, `/count`, {
      params: {
        filter: filter,
      },
    })
    yield put(
      OperatorAlertsActions.fetchOperatorsAlertsCountSuccess(data.count),
    )
  } catch (e) {
    yield put(OperatorAlertsActions.fetchOperatorsAlertsCountFail())
    handleError(e)
  }
}
export function* editAlert({ alertId, alert }) {
  yield put(OperatorAlertsActions.editAlertLoading())
  try {
    const { data } = yield call(
      operatorsAlertApiService.patch,
      `/${alertId}`,
      alert,
    )
    yield put(OperatorAlertsActions.editAlertSuccess(data))
    toaster.push(<IFToastMessage type="success" text={'Alert Edited'} />, {
      placement: 'topEnd',
    })
  } catch (e) {
    yield put(OperatorAlertsActions.editAlertFail())
    handleError(e)
  }
}

export function* deleteAlert({ alertId }) {
  yield put(OperatorAlertsActions.deleteAlertLoading())
  try {
    yield call(operatorsAlertApiService.delete, `/${alertId}`)
    yield put(OperatorAlertsActions.deleteAlertSuccess(alertId))
    toaster.push(<IFToastMessage type="success" text={'Alert Deleted'} />, {
      placement: 'topEnd',
    })
  } catch (e) {
    yield put(OperatorAlertsActions.deleteAlertFail())
    handleError(e)
  }
}
export function* createAlert({ alert }) {
  yield put(OperatorAlertsActions.createAlertLoading())
  try {
    const { data } = yield call(operatorsAlertApiService.post, `/`, alert)
    yield put(OperatorAlertsActions.createAlertSuccess(data))
    toaster.push(<IFToastMessage type="success" text={'Alert Added'} />, {
      placement: 'topEnd',
    })
  } catch (e) {
    yield put(OperatorAlertsActions.createAlertFail())
    handleError(e)
  }
}
